// extracted by mini-css-extract-plugin
module.exports = {"overlay":"Overlay_overlay__N8qKi","fixed":"Overlay_fixed__3iitA","animateIn":"Overlay_animateIn__v8q48","animateOut":"Overlay_animateOut__Swa4j"};